import {
  Button,
  EButtonColorVariant,
  GeneralListIcon,
  GeneralMapOutlineIcon,
} from '@outdoorsyco/bonfire';
import { FormattedMessage } from 'react-intl';

interface MobileMapListToggleProps {
  isMapOpen: boolean;
  onToggle: () => void;
  testId?: string;
  zIndex?: string;
}

export const MobileMapListToggle = ({
  isMapOpen,
  onToggle,
  testId,
  zIndex = 'z-30',
}: MobileMapListToggleProps) => {
  const defaultTestId = isMapOpen ? 'search-list-btn' : 'search-map-btn';
  const buttonTestId = testId || defaultTestId;

  return (
    <div className={`fixed ${zIndex} flex justify-center w-full select-none bottom-7`}>
      <div className="flex flex-row items-center xl:hidden gap-x-3">
        <Button
          className="!bg-white hover:!bg-white !border-none shadow-100"
          data-testid={buttonTestId}
          variant={EButtonColorVariant.Tertiary}
          onClick={onToggle}
          label={
            <div className="flex items-center justify-center gap-2">
              {isMapOpen ? (
                <GeneralListIcon className="text-gray-850" />
              ) : (
                <GeneralMapOutlineIcon className="text-gray-850" />
              )}
              <span className="text-gray-850">
                {isMapOpen ? (
                  <FormattedMessage
                    defaultMessage="List"
                    id="Me9t+O"
                    description="Mobile map/list toggle - List view button label"
                  />
                ) : (
                  <FormattedMessage
                    defaultMessage="Map"
                    id="ZxoJme"
                    description="Mobile map/list toggle - Map view button label"
                  />
                )}
              </span>
            </div>
          }
        />
      </div>
    </div>
  );
};
